<template>
  <div>
    <v-card flat>
      <v-card-text>
        <v-container fluid>
          <v-expansion-panel>
            <v-expansion-panel-content
              v-for="(item, index) in value"
              :key="index"
            >
              <template v-slot:header>
                <div>{{ item.label }}</div>
              </template>
              <v-flex v-if="item.relatedValue" xs12 class="m-4" :key="index+'1'" style="border: 1px dashed orange">
               <span><strong>Kommentar fra innflytting:</strong> {{item.relatedValue}}</span>
              </v-flex>
              <v-flex xs12 class="text-center m-4" :key="index">
                <v-textarea box :name="item.id" :label="item.label" :hint="item.hint" v-model="item.value" @input="updateMessage"></v-textarea>
              </v-flex>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
  export default {
    props: ['value'],
    methods: {
      updateMessage (e) {
        this.$emit('update-fields');
      }
    }
  }
</script>
